export enum UtilCssClasses {
	NO_TRANSITIONS = 'no-transitions',
}
